module.exports = __webpack_public_path__ + "img/codelogo.13df8391.png";